// import _ from 'lodash';

const orders3pl = {
  isLoading: false,
  opened: '',
  list: {},
}
const Orders3PLReducer = function (state = orders3pl, action) {
  switch (action.type) {
    case 'TOGGLE_ORDERS_3PL_LOADING': {
      return {
        ...state,
        isLoading: action.value,
      }
    }
    case 'SELECT_ORDER_3PL': {
      return {
        ...state,
        opened: action.order,
      }
    }
    case 'UPDATE_ORDERS_3PL': {
      let newList = {}
      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.list[key], ...value }))
      return {
        ...state,
        list: {
          ...state.list,
          ...newList,
        },
      }
    }
    default: {
      return state
    }
  }
}

export default Orders3PLReducer
